import { render, staticRenderFns } from "./provideHeKangWorkOrder.vue?vue&type=template&id=2485adcd&scoped=true&"
import script from "./provideHeKangWorkOrder.vue?vue&type=script&lang=js&"
export * from "./provideHeKangWorkOrder.vue?vue&type=script&lang=js&"
import style0 from "./provideHeKangWorkOrder.vue?vue&type=style&index=0&id=2485adcd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2485adcd",
  null
  
)

export default component.exports